export class RequestError extends Error {
  constructor(response, _method = 'GET') {
    super(response.statusText || 'Request failed');
    this.status = response.status;
    this.url = response.url;
    // this.name = 'RequestError';
    Object.defineProperties(this, {
      headers: {
        get() {
          return response.headers;
        },
      },
    });
  }
}
